export const GUI_USERINFO = localStorage.getItem("gui-userInfo");
export const GUI_ISADMIN = localStorage.getItem("interactingAdmin");
export const GUI_USERID = localStorage.getItem("gui-userId");